import logo from './logo.svg';
import './App.css';

// notificações
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// rotas
import { RoutesApp } from './routes';

// context
import { AuthProvider } from './context/AuthContext';
import { UserDataProvider } from './context/UserDataContext';
import Modal from 'react-modal';

Modal.setAppElement('#root');

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <UserDataProvider>
          <RoutesApp />
        </UserDataProvider>
      </AuthProvider>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          zIndex: 999999,
        }}
      />
    </div>
  );
}

export default App;
